import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { sanitizeDescriptionRemovePayee } from 'components/ledger-entry-editor/utils/sanitize';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import InvolvedPartisTable from './involved-parties-table';

const useStyles = makeStyles((theme: any) => ({
  title: {
    fontSize: '1rem',
    fontWeight: 500,
    color: theme.palette.primary.darker,
    overflowWrap: 'anywhere',
  },
  subtitle: {
    marginTop: theme.spacing(0.5),
    fontSize: '0.75rem',
    color: theme.palette.primary.light,
  },
  closeText: {
    textTransform: 'none',
    color: theme.palette.primary.main,
    fontWeight: 500,
  },
}));

type InvolvedPartiesDialogProps = {
  open: boolean;
  ledgerRow: any;
  onClose: () => void;
  handleEditLedgerAssociation: (row: any) => void;
  handleDeleteLedgerAssociation: (row: any) => void;
};

const InvolvedPartiesDialog: FC<InvolvedPartiesDialogProps> = ({
  open,
  ledgerRow,
  onClose,
  handleEditLedgerAssociation,
  handleDeleteLedgerAssociation,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const parties = ledgerRow?.involved_parties || [];
  const description = ledgerRow
    ? sanitizeDescriptionRemovePayee(ledgerRow.description, ledgerRow.involved_parties)
    : '';

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          onClose();
        }
      }}
      fullWidth
      maxWidth="md"
      fullScreen={isMobile}
    >
      <DialogTitle>
        <Typography component="div" className={classes.title}>
          {description}
        </Typography>
        <Typography component="div" className={classes.subtitle}>
          {`${t('accounting:parties')} (${parties.length})`}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        {ledgerRow && (
          <InvolvedPartisTable
            ledgerRow={ledgerRow}
            handleEditLedgerAssociation={handleEditLedgerAssociation}
            handleDeleteLedgerAssociation={handleDeleteLedgerAssociation}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button color="primary" variant="outlined" disableElevation onClick={onClose}>
          <Typography variant="body2" className={classes.closeText}>
            {t('common:close')}
          </Typography>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InvolvedPartiesDialog;
